<template>
  <div>
    <slot :handler="onUploadFileClicked">
      <v-btn v-bind="$attrs" @click="onUploadFileClicked">
        <slot name="btnInner"></slot>
      </v-btn>
    </slot>
    <input
      style="display: none"
      type="file"
      @change="handleFilesSelected"
      :accept="accept || '*'"
      ref="uploadRef"
      :multiple="multiple"
    />
  </div>
</template>
<script lang="ts" >
import { Component, Vue, Prop } from "vue-property-decorator";
import { toBinaryString } from "@/utils";
import { FCFile } from "@/types";
import { _2_TO_THE_POWER_20 } from "@/config/const";

@Component({
  name: "FileChooser",
  inheritAttrs: false,
})
export default class extends Vue {
  @Prop(Boolean) multiple!: boolean;
  @Prop({ type: String, default: "*" }) accept!: string;
  @Prop({ type: Number, default: 2 }) maxSize!: number;

  outputBinary = true;

  onUploadFileClicked() {
    (this.$refs.uploadRef as HTMLElement).click();
  }

  async processFiles(selectedFiles: FileList) {
    const validFiles: FCFile[] = [];
    const notValidFiles: FCFile[] = [];

    if (selectedFiles) {
      await Promise.all(
        Array.from(selectedFiles).map(async (file) => {
          if (new Blob([file]).size <= this.maxSize * _2_TO_THE_POWER_20) {
            const fileData = this.outputBinary
              ? file
              : await toBinaryString(file);
            validFiles.push({
              name: file.name,
              data: fileData,
              type: file.type,
            });
          } else {
            notValidFiles.push({
              name: file.name,
              error: this.$t("fileMax", [this.maxSize]) as string,
            });
          }
        })
      );
    }

    this.$emit("filesReady", validFiles, notValidFiles);
  }
  async handleFilesSelected(event: Event) {
    const selectedFiles = (event.target as HTMLInputElement).files;
    if (selectedFiles) this.processFiles(selectedFiles);
  }
}
</script>
<style lang="scss" >
</style>